module.exports = __webpack_public_path__ + "img/巡检任务.5bac0638.png";